<template>
  <div class="left-main">
    <div>
      <el-menu
          :default-active="$route.name ? $route.name : menuindex"
          class="el-menu-vertical-demo"
          @select="handleselect"
      >
<!--        <img-->
<!--            src="../../assets/icon/logo.png"-->
<!--            alt=""-->
<!--            width="40px"-->
<!--            style="margin:15px 25px 0 25px"-->
<!--        />-->
        <p style="margin:15px 25px 0 25px;height: 40px;"></p>
        <div v-if="this.isswitch">
          <el-menu-item :index="item.indexKey" @click="()=>{item.method}" v-for="(item,index) in menuList.slice()">
            <template slot="title">
              <img :src="item['img'+(menuindex == item.indexKey ? 'Active': '')]" alt="" class="menu_img"/>
              <p class="fontcolor" :class="{ projectactive: menuindex == item.indexKey }">
                {{ item.name }}
              </p>
            </template>
          </el-menu-item>
        </div>
      </el-menu>
    </div>
    <div class="left_bottom">
      <div class="bot-div" @click="downLoad">
        <img src="../../assets/icon/downLoadIcon.png" alt="" class="menu_icon" v-if="!this.downLoadActive"/>
        <img src="../../assets/icon/downLoadIconActive.png" alt="" class="menu_icon" v-if="this.downLoadActive"/>
        <el-badge :value="downCount" :hidden="downCount === 0">
          <p class="fontcolor" :class="{'downLoadClass' : this.downLoadActive == true}">
          Download</p></el-badge>
      </div>
      <div class="bot-div" @click="trumpetBtn">
        <img src="../../assets/icon/trumpeticon.png" alt="" class="menu_icon" v-if="!this.trumpetType"/>
        <img src="../../assets/icon/trumpeticonActive.png" alt="" class="menu_icon" v-if="this.trumpetType"/>
        <el-badge :value="msgCount" :hidden="msgCount == 0">
          <p class="fontcolor" :class="{'trumpetClass' : this.trumpetType == true}">
          Log</p></el-badge>
      </div>
      <ul style="list-style-type: none;text-align: center;width:90%;">
        <li class="popOne">
          <el-popover
              placement="right"
              width="250"
              trigger="click"
              ref="refNamePopover"
              style="padding: 0px !important; bottom: 13px !important;left:78px;"
          >
            <div class="poplist">
              <div class="poplist-left">
                <div class="popover-top">
                  <img class="bottom_img" v-if="!this.accountInfo.avatar" src="../../assets/icon/avatar.png">
                  <img :src="this.avatarUrl" alt="" v-else class="bottom_img"/>
                  <div class="popover-top-right">
                    <p>E-mail:</p>
                    <p v-if="this.accountInfo.email">{{this.accountInfo.email}}</p>
                    <p v-if="this.userData.phonenumber">{{ this.phoneNumber }}</p>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="popover-content">
                  <p @click="backHome"><i class="el-icon-s-home"></i>Home Page</p>
                </div>
                <div class="popover-gohome">
                  <el-button @click="goOut" type="danger" round>Sign Out</el-button>
                </div>
              </div>
            </div>
            <!--            <img slot="reference" class="bottom_img" src="../../assets/icon/avatar.png">-->
            <img :src="this.avatarUrl" @error="imgOnError" slot="reference" alt="" class="bottom_img"/>
          </el-popover>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  getInfo,
  getNotificationUnreadCount
} from "../../request/business";
import Cookies from "js-cookie";
import {EventBus} from "../../utils/event-bus";
import store from '@/store'
import {dlTaskLit} from "@/request/private";

export default {
  data() {
    return {
      userName: "",
      visible: false,
      menuindex: "",
      isswitch: true,
      organType: true,
      accountInfo: {
        userName: "",
        token: "",
        userId: "",
        avatar: '',
      },
      enterCont: "",
      enterStatus: "true",
      // refNamePopover: "",
      phoneNumber: "",
      avatarUrl: '',
      msgCount: 0,
      downCount: 0,
      downLoadActive: false,
      trumpetType: false,
      helpType: false,
      menuList: [
        {
          name: 'My Project',
          path: '/myProject',
          img: require('@/assets/icon/project.png'),
          imgActive: require('@/assets/icon/projectactive.png'),
          indexKey: 'myProject',
          method: this.mywodrd()
        }
      ],
      userData:{}
    };
  },

  destroyed() {
    // 销毁vm组件
    // 避免堆栈溢出，多次创建、多次触发
    window.removeEventListener("popstate", this.popstate, false);
  },
  created() {
    EventBus.$on("REFRESH_NOTIFICATION_NUM", this.refreshNotificationNum)
    let queryUrl = this.$route.query;

    if (queryUrl.encodeCont != undefined) {
      let decodes = JSON.parse(this.$Base64.decode(queryUrl.encodeCont));
      this.accountInfo.token = decodes.token;
      this.accountInfo.userId = decodes.userId;
    }

    // 浏览器控制按钮前进后退触发函数
    window.addEventListener("popstate", this.popstate, false);
    this.enterStatus = sessionStorage.getItem("enterStatus") || "true";

    this.enterCont = sessionStorage.getItem("enterCont");
    this.menuindex = sessionStorage.getItem('menucharge') || 'myProject'
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.user.user != null) {
        this.userData = this.$store.state.user.user
        this.userName = this.userData.userName;
        this.accountInfo.userName = this.userData.nickName;
        this.accountInfo.avatar = this.userData.avatar
        this.accountInfo.email = this.userData.email
        this.phoneNumber = this.userData.userName;
        this.accountInfo.userId = this.userData.userId;
        this.avatarUrl = `${process.env.VUE_APP_BASE_API}` + this.userData.avatar
        this.enterStatus = sessionStorage.getItem("enterStatus") || "true";
      }
    });
    this.refreshNotificationNum()
    EventBus.$on("aMsg", (msg) => {
      // A发送来的消息

    });
    console.log('this.accountInfo',this.accountInfo)
  },

  methods: {
    // 点击通讯录
    addresss() {
      //  sessionStorage.setItem("enterStatus",0);
      //  sessionStorage.setItem("vva", 1);
      this.meibus.$emit('wdhy', 1)

    },
    // 点击我的项目
    mywodrd() {
      sessionStorage.removeItem('projectRecharge_shouye')

      this.meibus.$emit('wordrd', 0)
    },
    popstate() {
      this.$nextTick(() => {
        for (let menuListElement of this.menuList) {
          if (window.location.pathname.indexOf(menuListElement.path) > -1) {
            this.menuindex = menuListElement.indexKey
          }
        }
      });
    },
    // 回到首页
    backHome() {
      sessionStorage.setItem('projectRecharge', 0)
      sessionStorage.setItem('homeRechare', 0)
      sessionStorage.setItem('dataRechare', 0)
      this.$router.push("/home/newHome");
    },
    handleselect(key, keyPath) {
      EventBus.$emit("aMsg", '来自A页面的消息');
      EventBus.$emit("Model", '来自A页面的消息');
      sessionStorage.removeItem('graph_save')
      sessionStorage.setItem('menucharge', key)
      sessionStorage.setItem('projectRecharge', 0)
      sessionStorage.removeItem('projectRecharge_shouye')
      // this.$store.commit('getIndex',key)
      this.menuindex = key;
      if (key == "myProject") {
        this.$router.push("/myProject");
      } else if (key == 'myTeam') {
        this.$router.push("/myTeam");
        EventBus.$emit('barType', false)
        EventBus.$emit("rechargeIndex", 0)
      } else if (key == "address") {
        this.$router.push("/contacts");
      } else if (key == "framework") {
        this.$router.push("/Organization");
      } else if (key == 'Model') {
        EventBus.$emit("Model", '来自menu页面的消息');
        this.$router.push("/ModelBase");
      } else if (key == 'dataSpace') {
        EventBus.$emit("dataSpace", '来自menu页面的消息');
        this.$router.push("/DataSpace");
      } else if (key == 9) {
        this.$router.push("/JoinEnterprise");
      }
      this.downLoadActive = false
      this.trumpetType = false
      this.helpType = false
    },
    accountSetup() {
      let routeUrl = this.$router.resolve({
        path: "/InvitationNotice",
        query: {
          recharge: 0,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    trumpetBtn() {
      this.trumpetType = true
      this.downLoadActive = false
      this.helpType = false
      this.menuindex = ''
      EventBus.$emit('readType', true)
      sessionStorage.setItem('informatcharge', 0)
      this.$router.push("/information/unread");
    },
    helpcenter() {
      sessionStorage.setItem("helpGb", this.$route.path)
      this.helpType = true
      this.trumpetType = false
      this.downLoadActive = false
      this.menuindex = ''
      let routeUrl = this.$router.resolve({
        path: "/helpCenter",
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push("/helpCenter");
    },
    goOut() {
      this.$store.dispatch("FedLogOut")
      sessionStorage.clear();
      localStorage.clear();
      EventBus.$emit("DESTROY_WS")
      this.$router.push({path: "/login", query: {types: '0'}});
    },
    imgOnError() {
      this.avatarUrl = require('@/assets/icon/avatar.png')
    },
    async refreshNotificationNum() {
      let resp = await getNotificationUnreadCount();
      if (resp.success) {
        this.msgCount = resp.result
      }
      let downList = await dlTaskLit();
      if (downList.success) {
        this.downCount = downList.result.length
      }
    },
    downLoad() {
      this.downLoadActive = true
      this.trumpetType = false
      this.helpType = false
      this.menuindex = ''
      this.$router.push("/downLoad");
    }
  },
};
</script>
<style lang="scss" scoped>
.left-main {
  width: 95%;
  height: 100%;
  background-color: #ffffff;
  // background: url(../../assets/icon/back.png);
  .el-col-12 {
    width: 100%;
    height: 100% !important;
  }

  .bot-div {
    //width: 75%;
    margin: 20px auto;
    display: flex;
    cursor: pointer;

    img {
      margin-left: 10px;
    }

    ::v-deep .el-badge {
      ::v-deep .el-badge__content.is-fixed {
        right: 0 !important;
      }

      .el-badge__content {
        height: 20px !important;
      }
    }
  }

  .downLoadClass, .trumpetClass, .helpClass {
    color: #004080 !important;
  }

  .title {
    width: 90%;
    font-size: 20px;
    color: white;
    margin: 0 auto;
    text-align: center;
    line-height: 30px;
  }

  .menu_img {
    width: 20px;
    // margin-left: -2px;
    margin-top: 8px;
  }

  .menu_icon {
    width: 15px;
    height: 15px;
    margin: 3px 5px 0 0;
  }

  .fontcolor {
    color: #333;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
  }

  .font-title {
    font-size: 12px;
    margin-left: -10px;
  }

  .projectactive {
    color: #004080;
    text-align: center;
  }

  .addressactive {
    color: #004080;
  }

  .teamactive {
    color: #004080;
  }

  .modelactive {
    color: #004080;
  }

  .dataSpaceactive {
    color: #004080;
  }

  .moreactive {
    color: #004080;
    //margin-left: -6px;
  }

  .joinEnterprise {
    font-size: 12px;
    color: #004080;
    margin-left: -17px;
  }

  .notice {
    font-size: 12px;
    color: #004080;
    margin-left: -17px;
  }

  .left_bottom {
    width: 90px;
    position: fixed;
    bottom: 0px;
    //left: -25px;

    .bottom_img {
      width: 45px;
      margin-top: 20px;
      border-radius: 50px;
    }
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    height: 100%;
  }

  .el-menu--collapse {
    width: 97%;
    height: 100%;
  }

  .el-menu {
    border-right: 0px !important;
    background-color: transparent !important;
  }

  .el-menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-menu-item,
  .el-submenu__title {
    line-height: 25px !important;
    margin: 12px 0;
  }

  .el-icon-menu {
    margin-top: 10px !important;
  }

  .el-menu-item.is-active {
    width: 80% !important;
    background: white !important;
    border-radius: 10px;
    // opacity: 0.5;
    position: relative;
    left: 10%;
  }

  .el-menu-item:hover {
    background: transparent !important;
  }

  .el-submenu__title:hover {
    background: transparent !important;
  }

  .enterList {
    list-style: none;

    .enterName {
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      margin-left: 10px;

      .enterNametext {
        width: 101%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
      }

      .dele {
        width: 53%;
        height: 30px;
        position: relative;
        right: 1px;
        line-height: 30px;
        background: white;
        text-align: center;
        display: none;
        color: red;
      }

      .icons {
        display: none;
      }
    }

    .enterName:hover {
      color: #004080;

      .dele {
        display: block;
        color: red;
      }
    }
  }

  .enterlistName {
    color: #004080;
  }

  .enterIcon {
    display: block;
  }

  .enterColor {
    color: #000;
  }

  .accountBottom {
    display: flex;
    justify-content: space-around;

    span {
      display: block;
      color: #004080;
      cursor: pointer;
      line-height: 30px;
      font-size: 14px;

      i {
        margin-right: 5px;
      }
    }
  }

  .enterList-scroll {
    height: 100px;
    overflow-y: scroll;
  }

  // 去除滚动条
  .wrapper .enterList-scroll::-webkit-scrollbar {
    display: none;
  }

  //.el-menu-item.is-active {
  //  background: #d3d7d4 !important ;
  //}

  .poplist-right {
    width: 35%;
    background: #f7f7f7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    padding-bottom: 12px;
    padding-top: 20px;
    padding: 0px;
  }

  .el-popper {
    padding: 0px !important;
  }

  .el-popover {
    padding: 0px !important;
    top: 496px !important;
    bottom: 13px !important;
    left: 56px !important;

    overflow: hidden;
  }

  .el-menu-item {
    padding: 0 !important;
  }

  .el-menu-item.is-active {
    padding: 0 !important;
  }

  .el-divider--horizontal {
    margin: 0 !important;
  }
}

.poplist {
  width: 100%;
  height: 100%;
  display: flex;

  .poplist-left {
    width: 100%;

    .popover-top {
      width: 100%;
      height: 60px;
      padding: 10px;
      display: flex;
      margin-top: 5px;

      img {
        width: 40px;
        border-radius: 50%;
      }

      .bottom_img {
        width: 45px;
        height: 45px;
        border-radius: 50px;
      }

      .popover-top-right {
        margin: 5px 0 0 15px;

        p {
          //height: 28px;
          //line-height: 30px;
          font-size: 14px;
          cursor: pointer;
        }

        //p:hover {
        //  background: #e4e7ed;
        //}
      }
    }

    .popover-content {
      height: 50px;
      margin-top: 20px;

      p {
        margin: 5px 25%;
        cursor: pointer;

        .el-icon-s-home {
          padding-right: 3px;
        }
      }
    }

    .popover-gohome {
      width: 90%;
      height: 60px;
      margin: 0 auto;

      .el-button {
        width: 100%;
        //margin: 0 auto;
      }
    }
  }

}
</style>
